import React, { useState, useEffect, useContext } from 'react';
import {addDays, format} from "date-fns";

import * as utils from "../../assets/utils";
import * as net from "../../lib/net";
import Td_Sel from "../../lib/ui/td_sel";
import Dt_Cal from "../../lib/ui/dt_cal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Calc_Per extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_fd = React.createRef();
    this.dt_td = React.createRef();

    this.store = props.store;

    this.state = {};
    this.state.avd = "";
    this.state.dta = [];
    this.state.kro = {};
    this.state.aa = [];
    this.state.wnds = {};
    this.state.sortid = "";
    this.state.sortdir = 1;

    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    //var tdat = addDays(this.state.today, 15);
    //var tdat = subDays(this.state.today, 15);
    let cdat = new Date();
      //let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1) + "-" + cdat.getDate();
      let formatted_date = cdat.getFullYear() + "-" + (cdat.getMonth() + 1) + "-" + "01";
    this.state.fdat = formatted_date;
    this.state.tdat = dts;

    this.selitems = [
      {fkn: 'open', text: 'ÖPPNA'},
      {fkn: 'prn', text: 'SKRIV UT'}
    ];
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.per_day();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      css.overflow = "auto";
      return css;
  }
    th_style(id) {
        var css = {};
        css.cursor = "pointer";
        if(id == this.state.sortid) {
            if(this.state.sortdir) css.color = "#800";
            else css.color = "#080";
        }
        return css;
    }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }
    dt_fdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ fdat: dts });
    }
    dt_tdat(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ tdat: dts });
    }
    oneday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_td.current.updateDt(this.state.fdat);
    }
    addday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateAdd();
        this.dt_td.current.updateAdd();
    }
    subday(e) {
        //alert(JSON.stringify(e));
        //this.setState({ tdat: this.state.fdat });
        this.dt_fd.current.updateSub();
        this.dt_td.current.updateSub();
    }

  ee_edit(row) {
    var self = this;
    var wnds = {};
    wnds.eeper = 1;
      wnds.fdat = this.state.fdat;
      wnds.tdat = this.state.tdat;
      wnds.eeo = row;
    this.setState({wnds: wnds});
  }
  fkn_close() {
    this.setState({edit: false });
    //this.props.history.push("cas");
    //this.login_srv(uid, pwd);
  }

  per_day() {
    var self = this;
    var prm = {};
    prm.req = "ta.ta_calc.per_dag";
    prm.fdat = this.state.fdat;
    prm.tdat = this.state.tdat;
    //prm.avd = this.state.avd;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({ dta: ret.rca }, function () {
            self.syncTb("dayTable");
        });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    syncTb(tb) {
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
            tdElements = tbel.getElementsByTagName('td');
        if(tdElements.length < 1 ) return;

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
                width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    tb_sort(typ) {
        var self = this;
        //var rvs = self.state.rvs;
        var dta = self.state.dta;
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;

        if(sortid != typ) sortdir = 0;
        else {
            if(sortdir) sortdir = 0;
            else sortdir = 1;
        }

        if(typ) {
            if(sortdir) dta.sort((a,b) => (a[typ] < b[typ]) ? 1 : ((b[typ] < a[typ]) ? -1 : 0));
            else dta.sort((a,b) => (a[typ] > b[typ]) ? 1 : ((b[typ] > a[typ]) ? -1 : 0));
        }
        self.setState({ dta: dta, sortid: typ, sortdir: sortdir });
    }
    th_icon(typ) {
        var cls = "";
        var sortid = this.state.sortid;
        var sortdir = this.state.sortdir;
        if(sortid == typ)
        {
            if(sortdir) cls = "fa fa-caret-up";
            else cls = "fa fa-caret-down";
        }
        return cls;
    }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row flex-space-between">
        <div className="label_h03">PERIOD KALKYL</div>
        <div className="flex"></div>
        <div className="flex-row">
            <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
            <Dt_Cal dts={ this.state.fdat } rp="1" ref={this.dt_fd} getValue={(e)=> this.dt_fdat(e)} />
            <div className="dt-btn-01" onClick={() => this.oneday() } >1</div>
            <Dt_Cal dts={ this.state.tdat } rp="1" ref={this.dt_td} getValue={(e)=> this.dt_tdat(e)} />
            <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
        </div>
        <div className="flex"></div>
        <button className="btn btn-hw-blue w150" onClick={() => this.per_day() } aria-label="System" >
            UPPDATERA
        </button>
    </div>
    <div className="divider"></div>

        <div id="dayTable" className="web-col">
            <table className="table table-bordered table-hover tb " style={{marginBottom: "0px"}}>
                <thead>
                <tr>
                    <th style={ this.th_style("datum") } onClick={() => this.tb_sort("datum") }>Dag <i className={ this.th_icon("datum") }></i></th>
                    <th style={ this.th_style("text") } onClick={() => this.tb_sort("text") }>Text <i className={ this.th_icon("text") }></i></th>
                    <th style={ this.th_style("nrp") } onClick={() => this.tb_sort("nrp") }>Personer <i className={ this.th_icon("nrp") }></i></th>
                    <th style={ this.th_style("wrktid") } onClick={() => this.tb_sort("wrktid") }>Arbetad tid <i className={ this.th_icon("wrktid") }></i></th>
                    <th style={ this.th_style("lon") } onClick={() => this.tb_sort("lon") }>Lön <i className={ this.th_icon("lon") }></i></th>
                    <th style={ this.th_style("ob1lon") } onClick={() => this.tb_sort("ob1lon") }>OB1 Lön <i className={ this.th_icon("ob1lon") }></i></th>
                    <th style={ this.th_style("ob2lon") } onClick={() => this.tb_sort("ob2lon") }>OB2 Lön <i className={ this.th_icon("ob2lon") }></i></th>
                    <th style={ this.th_style("tlon") } onClick={() => this.tb_sort("tlon") }>Summa <i className={ this.th_icon("tlon") }></i></th>
                    <th></th>
                </tr>
                </thead>
            </table>
            <div className="tb-cdi" style={ this.tb_style() }>
                <table className="table table-bordered table-hover tb">
                    <tbody>
                    { this.state.dta.map((row, key) =>
                        <tr key={key} onDoubleClick={() => this.ee_edit(row) }>
                            <td className="text-center">{ utils.toDate( row.datum ) }</td>
                            <td className="text-center">{ utils.toLang( row.text ) }</td>
                            <td className="text-center">{ row.nrp }</td>
                            <td className="text-center">{ utils.toMinTid(row.regtid) }</td>
                            <td className="text-right">{ utils.toPris( row.lon ) }</td>
                            <td className="text-right">{ utils.toPris( row.ob1lon ) }</td>
                            <td className="text-right">{ utils.toPris( row.ob2lon ) }</td>
                            <td className="text-right">{ utils.toPris( row.tlon ) }</td>
                            <td>
                                <Td_Sel items={ this.selitems } getValue={(e)=> this.sel_row_fkn(row, e)} />
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>

   </div>
  );
    }
}
export default Calc_Per;
